import { cn } from "@/lib/utils";
import type { ReportModel } from "@/lib/report";
import { ReportBasis } from "./ReportBasis";
import { ReportCover } from "./ReportCover";
import { ReportGraphs } from "./ReportGraphs";
import { ReportPage, type ReportVariant } from "./ReportPage";
import { ReportSummary } from "./ReportSummary";
import { ReportTakeaways } from "./ReportTakeaways";
import { ReportTopRisks } from "./ReportTopRisks";

interface ClimateRiskReportProps {
  model: ReportModel;
  variant: ReportVariant;
}

/**
 * Props-only: no fetching, no router/auth/Shell dependency, so the live
 * preview and the headless print route render the exact same tree from the
 * exact same ReportModel. Section order is fixed by the spec (§ Report content).
 */
export function ClimateRiskReport({ model, variant }: ClimateRiskReportProps) {
  const page = { variant, companyName: model.workspaceName };

  return (
    <div
      className={cn(
        // Block, not flex, in the PDF variant — see ReportPage's note on Chromium flex fragmentation.
        "font-sans text-foreground [-webkit-print-color-adjust:exact] [print-color-adjust:exact]",
        variant === "screen" && "flex flex-col gap-8",
      )}
    >
      <ReportPage {...page} bleed>
        <ReportCover model={model} variant={variant} />
      </ReportPage>
      <ReportPage {...page}>
        <ReportSummary model={model} />
        <ReportTakeaways model={model} />
      </ReportPage>
      <ReportPage {...page}>
        <ReportGraphs model={model} />
      </ReportPage>
      <ReportPage {...page} last>
        <ReportTopRisks model={model} />
        <ReportBasis model={model} />
      </ReportPage>
    </div>
  );
}
